import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface';
import { DefenderForCloudFilterConfig } from './filters/DefenderForCloudFilterConfig';
import { DefenderForCloudConstants } from 'src/Common/Models/DefenderForCloudConst';

export const DefenderForCloudTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.DefenderForCloud],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: DefenderForCloudFilterConfig as any,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: DefenderForCloudFilterConfig as any,
      AreaPath: [UATConstants.DefenderForCloudAreaPath],
      Title: UATConstants.TenantTitles.DefenderForCloud,
      ADOTitle: UATConstants.TenantADOText.DefenderForCloud,
      hideCreateButton: false,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateDefenderForCloudRequestTitle,
          Key: UATConstants.CreateActionMenuKey.CreateDefenderForCloudRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'defenderforcloud',
        title: UATConstants.PlaceholdersAndTitles.DefenderForCloud,
        excelColumnSequence: {
          'Title': 1,
          'Assigned Team': 2,
          'Action Owner': 3,
        },
      },
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedTo', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'requestor', formFieldLabel: UATConstants.PlaceholdersAndTitles.Requestors, apiFieldName: 'requestorsinfo' },
        { formFieldName: 'DEF_AEAlias', formFieldLabel: DefenderForCloudConstants.PlaceholdersAndTitles.AEName, apiFieldName: 'def_ae_alias' },
        { formFieldName: 'DEF_Requestor_Manager', formFieldLabel: DefenderForCloudConstants.PlaceholdersAndTitles.RequestorManager, apiFieldName: 'def_requestor_manager' },
        { formFieldName: 'DEF_Exception_Approver', formFieldLabel: DefenderForCloudConstants.PlaceholdersAndTitles.ExceptionApprover, apiFieldName: 'def_exception_approver' },
        { formFieldName: 'DEF_CEAlias', formFieldLabel: DefenderForCloudConstants.PlaceholdersAndTitles.CEName, apiFieldName: 'def_ce_alias' },
        { formFieldName: 'DEF_SSNPAlias', formFieldLabel: DefenderForCloudConstants.PlaceholdersAndTitles.SSNPName, apiFieldName: 'def_ssn_alias' },
        { formFieldName: 'DEF_Notification_tobe_sent', formFieldLabel: DefenderForCloudConstants.PlaceholdersAndTitles.Notificationsent, apiFieldName: 'def_notification_tobe_sent' },
        { formFieldName: 'DEF_Optional_Area_Support_Lead', formFieldLabel: DefenderForCloudConstants.PlaceholdersAndTitles.OptionalAreaSupportLead, apiFieldName: 'def_optionalareasupportlead' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      // TODO: Replace with actual default view ID once created in backend for Defender For Cloud tenant
      defaultViewId: 'dad05f54-fd32-414b-a017-2cf39802c988',
      systemViewsFolderId: 'ae4fdb7f-2cd3-414d-8cb5-a20e6ef5dbf3',
      sharedViewsFolderId: '700ee1ab-d1f8-4d9d-9414-b09a7c5adc6b',
      dropdownValues: {},
    },
  },
};
